module.exports = __webpack_public_path__ + "img/graphics-7.6bef14ba.svg";